import React from 'react';
import g from 'glamorous';

export default ({ children }) => (
  <g.Div
    margin="0 auto"
    maxWidth="560px"
    padding="0 24px">
    { children() }
  </g.Div>
);



// WEBPACK FOOTER //
// ./src/layouts/index.js